import type {Code} from 'services/codelists/types';
import {CodeListRef} from 'schemas/references';

const validProductFormDetails: Array<Code['code']> = [
  CodeListRef['PRODUCT_FORM_DETAIL']['Innbundet (papirvarer)'],
  CodeListRef['PRODUCT_FORM_DETAIL']['Heftet (papirvarer)'],
  CodeListRef['PRODUCT_FORM_DETAIL']['Spiral (papirvarer)'],
  CodeListRef['PRODUCT_FORM_DETAIL'][
    'Lærinnbinding / luksusinnbinding (papirvarer)'
  ],
];

/*
Only allow these options for PF (Dagbok) and PR (Notatbok):

P201 Innbundet (papirvarer)
P202 Heftet (papirvarer)
P203 Spiral (papirvarer)
P204 Lærinnbinding / luksusinnbinding (papirvarer)
 */
export const isInvalidDagbokorNotatbok = (
  code: Pick<Code, 'code'>,
  productForm: string,
): boolean => {
  // Ignore if productForm is not Dagbok or Notatbok, as these restrictions only apply to those product forms.
  if (
    productForm !== CodeListRef['PRODUCT_FORM'].Dagbok &&
    productForm !== CodeListRef['PRODUCT_FORM'].Notatbok
  ) {
    return false;
  }

  return !validProductFormDetails.includes(code.code);
};
